// extracted by mini-css-extract-plugin
export var large = "footer-module--large--cP0HO";
export var footer = "footer-module--footer--lU7l1";
export var footerColumn = "footer-module--footerColumn--OgPWw";
export var footerCookieBtn = "footer-module--footerCookieBtn--uHtzD";
export var footerBottomSection = "footer-module--footerBottomSection--LEwNn";
export var footerLogo = "footer-module--footerLogo--nDLxU";
export var matrixFigure = "footer-module--matrixFigure--Ug3kn";